import React from "react";
// MUI
import {Button, Grid, TextField, Typography} from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
// style
import {style} from "./style";

export default function QRCodeWifi(props: any) {

    let ssid: string = '';
    let passwd: string = '';

    if (!!props.fieldDisplay.ssid) ssid = props.fieldDisplay.ssid;
    if (!!props.fieldDisplay.password) passwd = props.fieldDisplay.password;

    return (
        <Grid item xs={12}>
            <Grid container sx={style.mainWrapper}>
                <Grid item sx={style.ssidItem}>
                    <Typography variant={'body1'}>
                        <strong>SSID: </strong> {ssid}
                    </Typography>
                </Grid>
                <Grid item sx={style.copy}>
                    <Button
                        variant={'contained'}
                        sx={style.button}
                        onClick={() => props.copyContentToClipBoard(ssid)}
                    >
                        <FileCopyIcon/>
                    </Button>
                </Grid>
                <Grid item xs={12} sx={style.spaceWithTop}></Grid>
                <Grid item>
                    <TextField
                        id="outlined-password-input"
                        label="Password"
                        type="password"
                        disabled
                        value={passwd}
                    />
                </Grid>
                <Grid item sx={style.copy} justifyItems={'center'}>
                    <Button
                        variant={'contained'}
                        sx={style.secondButton}
                        onClick={() => props.copyContentToClipBoard(passwd)}
                    >
                        <FileCopyIcon/>
                    </Button>
                </Grid>
                <Grid item xs={12} sx={style.spaceWithTop}></Grid>
                <Grid item sx={style.textSecurity}>
                    <Typography variant={'body1'}>
                        <strong>Security: </strong> {props.fieldDisplay.security}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}
